<template>
    <vue-scroll>
        <div class="page-header" style="margin-bottom: 15px">
            <h1>My Account</h1>
            <a href="https://corwindesign.com/terms" target="_blank"
                >Terms & Use Agreement</a
            >
        </div>
        <el-form style="max-width: 500px" class="mb-20">
            <el-form-item
                :class="accountForm.state('name')"
                label="Name"
                required
            >
                <el-input v-model="accountForm.name" />
                <form-feedback :form="accountForm" field="name" />
            </el-form-item>
            <el-form-item
                :class="accountForm.state('email')"
                label="Email"
                required
            >
                <el-input v-model="accountForm.email" />
                <form-feedback :form="accountForm" field="email" />
            </el-form-item>
            <el-form-item
                :class="accountForm.state('username')"
                label="Username"
            >
                <el-input v-model="accountForm.username" />
                <form-feedback :form="accountForm" field="username" />
            </el-form-item>
            <el-form-item
                :class="accountForm.state('phone_number')"
                label="Phone Number"
            >
                <el-input v-model="accountForm.phone_number" />
                <form-feedback :form="accountForm" field="phone_number" />
            </el-form-item>
            <div class="float-right">
                <el-button
                    :loading="accountForm.busy"
                    @click="submitAccount()"
                    icon="mdi mdi-content-save"
                    type="primary"
                >
                    Save Changes
                </el-button>
            </div>
            <div class="clearfix"></div>
        </el-form>
        <div style="max-width: 500px">
            <h3><i class="mdi mdi-textbox-password" /> Update Password</h3>
            <el-form>
                <el-form-item
                    label="Current Password"
                    required
                    :class="form.state('password')"
                >
                    <el-input type="password" v-model="form.password" />
                    <form-feedback :form="form" field="password" />
                </el-form-item>
                <el-form-item
                    label="New Password"
                    required
                    :class="form.state('new_password')"
                >
                    <el-input type="password" v-model="form.new_password" />
                    <form-feedback :form="form" field="new_password" />
                </el-form-item>
                <el-form-item
                    label="New Password Confirmation"
                    required
                    :class="form.state('new_password_confirmation')"
                >
                    <el-input
                        type="password"
                        v-model="form.new_password_confirmation"
                    />
                    <form-feedback
                        :form="form"
                        field="new_password_confirmation"
                    />
                </el-form-item>
                <div class="float-right">
                    <el-button
                        type="primary"
                        icon="mdi mdi-content-save"
                        @click="submit()"
                        :loading="form.busy"
                    >
                        Update Password
                    </el-button>
                </div>
                <div class="clearfix"></div>
            </el-form>
            <template v-if="current_corporation">
                <h3><i class="mdi mdi-textbox-password" /> Update Logo</h3>
                <el-form>
                    <edit-logo
                        :form="logoForm"
                        :corporation="current_corporation"
                    />
                    <div class="float-right">
                        <el-button
                            type="primary"
                            icon="mdi mdi-content-save"
                            @click="saveLogo()"
                            :loading="form.busy"
                            >Save Changes
                        </el-button>
                    </div>
                    <div class="clearfix"></div>
                </el-form>
            </template>
        </div>
        <div style="max-width: 700px">
            <h3>Notification Emails</h3>
            <div
                v-show="orderForm.email_bounced"
                style="color: red; font-weight: bold"
            >
                You are opted out because your email has bounced.
            </div>
            <div v-show="!orderForm.email_bounced">
                <div>
                    <el-switch
                        v-model="orderForm.order_update"
                        @change="updateNotification"
                        :disabled="orderForm.email_bounced"
                    />
                    <p class="d-inline-block m-5">Receive order updates</p>
                </div>
                <div>
                    <el-switch
                        v-model="orderForm.order_reminder"
                        @change="updateNotification"
                        :disabled="orderForm.email_bounced"
                    />
                    <p class="d-inline-block m-5">Receive order reminders</p>
                </div>
                <p>
                    Please note that you will always receive order confirmation
                    emails if you are the default or only user for an account.
                </p>
            </div>
        </div>
    </vue-scroll>
</template>

<script>
import * as Routes from "@/constants/routes.js";
import auth_mixin from "@/mixins/auth";
import * as Actions from "@/store/constants/actions";
import { mapState } from "vuex";
import EditLogo from "./../corporation/EditLogo";

export default {
    mixins: [auth_mixin],
    components: {
        EditLogo
    },
    data() {
        return {
            Routes,
            accountForm: new Form({
                name: null,
                email: null,
                username: null,
                phone_number: null
            }),
            orderForm: new Form({
                order_reminder: false,
                order_update: false,
                email_bounced: false
            }),
            form: new Form({
                password: null,
                new_password: null,
                new_password_confirmation: null
            }),
            logoForm: new Form({
                logo: null
            })
        };
    },
    mounted() {
        //console.log(this.auth.user);
        _.extend(
            this.accountForm,
            _.pick(this.auth.user, [
                "name",
                "email",
                "username",
                "phone_number"
            ]),
            {
                order_reminder:
                    this.auth.user.order_reminder == 1 ? true : false,
                order_update: this.auth.user.order_update == 1 ? true : false
            }
        );
        _.extend(this.orderForm, _.pick(this.auth.user, []), {
            order_reminder: this.auth.user.order_reminder == 1 ? true : false,
            order_update: this.auth.user.order_update == 1 ? true : false,
            email_bounced: this.auth.user.email_bounced == 1 ? true : false
        });
        //console.log(this.orderForm);
    },
    computed: {
        ...mapState(["current_corporation"]),
        canUpdateLogo() {
            return this.current_corporation;
        }
    },
    methods: {
        submit() {
            window.App.put(`/web-api/auth/password`, this.form).then(() => {
                this.$notify.success({
                    message: "Password has been updated."
                });
                this.form.clearFields();
            });
        },
        submitAccount() {
            window.App.put(`/web-api/auth/details`, this.accountForm).then(
                () => {
                    this.$notify.success({
                        message: "Changes have been saved."
                    });
                    this.$store.dispatch(Actions.UPDATE_USER);
                }
            );
        },
        updateNotification() {
            window.App.put(`/web-api/auth/details`, this.orderForm).then(() => {
                this.$notify.success({
                    message: "Changes have been saved."
                });
                this.$store.dispatch(Actions.UPDATE_USER);
            });
        },
        saveLogo() {
            App.putData(
                `/web-api/corporation/${this.current_corporation.id}`,
                this.logoForm
            ).then((response) => {
                this.$notify.success({
                    message: "Changes have been saved."
                });
                this.$store.dispatch(Actions.FETCH_CURRENT_CORPORATION);
            });
        }
    }
};
</script>

<style scoped></style>
